import { useEffect, useRef } from 'react';
import throttle from 'lodash/throttle';
import { useLayoutEffectWithoutSSRComplaining } from '@wix/da-hooks/pkg/useLayoutEffectWithoutSSRComplaining';
const THROTTLE_MS = 200;
export function useScrollRestore(isPageOpen) {
    const scrollPos = useRef(typeof window !== 'undefined' ? window.scrollY : 0);
    // Track wasOpen so we can avoid scrolling on pageload
    const wasOpen = useRef(false);
    useEffect(()=>{
        if (isPageOpen) {
            wasOpen.current = true;
        }
    }, [
        isPageOpen
    ]);
    // Track the window scroll and store it locally
    useEffect(()=>{
        if (typeof window !== 'undefined') {
            const handleScroll = throttle(()=>{
                requestAnimationFrame(()=>{
                    if (!isPageOpen) {
                        scrollPos.current = window.scrollY;
                    }
                });
            }, THROTTLE_MS);
            window.addEventListener('scroll', handleScroll, {
                passive: true
            });
            return ()=>window.removeEventListener('scroll', handleScroll);
        }
    }, [
        scrollPos,
        isPageOpen
    ]);
    // After rendering scroll to the last known position
    useLayoutEffectWithoutSSRComplaining(()=>{
        if (wasOpen.current && !isPageOpen && scrollPos) {
            window.scrollTo({
                top: scrollPos.current
            });
        }
    }, [
        isPageOpen
    ]);
}

//# sourceMappingURL=useScrollRestore.js.map